export enum TestOpsSubscriptionSource {
  RECURLY = 'RECURLY',
  TRIAL_REQUEST = 'TRIAL_REQUEST',
}
